// NotificationBanner.jsx - Place in src/components/NotificationBanner.jsx
import React, { useEffect, useState } from "react";
import { useNotifications } from "../hooks/useNotifications";

export const NotificationBanner = () => {
  const { notification, permissionStatus, enableNotifications, dismissNotification } =
    useNotifications();
  const [showPermissionBar, setShowPermissionBar] = useState(false);

  useEffect(() => {
    if (typeof Notification === 'undefined') return;
    if (permissionStatus === "default" && !localStorage.getItem("notification_asked")) {
      setShowPermissionBar(true);
    }
  }, [permissionStatus]);

  return (
    <>
      {/* Permission Request Bar */}
      {showPermissionBar && (
        <div style={styles.permissionBar}>
          <span>🐐 Enable notifications to stay updated on Elite Goats & Sheeps!</span>
          <div style={styles.actions}>
            <button
              style={styles.allowBtn}
              onClick={async () => {
                localStorage.setItem("notification_asked", "true");
                await enableNotifications();
                setShowPermissionBar(false);
              }}
            >
              Allow
            </button>
            <button
              style={styles.dismissBtn}
              onClick={() => {
                localStorage.setItem("notification_asked", "true");
                setShowPermissionBar(false);
              }}
            >
              Not now
            </button>
          </div>
        </div>
      )}

      {/* Live Notification Toast */}
      {notification && (
        <div style={styles.toast}>
          <div style={styles.toastIcon}>🐐</div>
          <div style={styles.toastContent}>
            <strong style={styles.toastTitle}>{notification.title}</strong>
            <p style={styles.toastBody}>{notification.body}</p>
          </div>
          <button style={styles.closeBtn} onClick={dismissNotification}>
            ✕
          </button>
        </div>
      )}
    </>
  );
};

const styles = {
  permissionBar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#2d5016",
    color: "white",
    padding: "12px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 9999,
    fontSize: "14px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
  },
  actions: {
    display: "flex",
    gap: "10px"
  },
  allowBtn: {
    backgroundColor: "#7cb518",
    color: "white",
    border: "none",
    padding: "6px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold"
  },
  dismissBtn: {
    backgroundColor: "transparent",
    color: "white",
    border: "1px solid rgba(255,255,255,0.5)",
    padding: "6px 16px",
    borderRadius: "6px",
    cursor: "pointer"
  },
  toast: {
    position: "fixed",
    top: "20px",
    right: "20px",
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    zIndex: 9999,
    maxWidth: "360px",
    border: "1px solid #e5e7eb"
  },
  toastIcon: { fontSize: "24px" },
  toastContent: { flex: 1 },
  toastTitle: { display: "block", marginBottom: "4px", color: "#111" },
  toastBody: { margin: 0, color: "#666", fontSize: "13px" },
  closeBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#999",
    fontSize: "16px"
  }
};
